import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import { ensureType as t } from "../symbols.js";
import i from "../core/Error.js";
import { clone as r } from "../core/lang.js";
import s from "../core/Logger.js";
import { isNone as l, unwrapOr as o, unwrap as n } from "../core/maybe.js";
import { deepMerge as a } from "../core/object.js";
import { property as u } from "../core/accessorSupport/decorators/property.js";
import { cast as p } from "../core/accessorSupport/decorators/cast.js";
import { enumeration as f } from "../core/accessorSupport/decorators/enumeration.js";
import { reader as d } from "../core/accessorSupport/decorators/reader.js";
import { subclass as c } from "../core/accessorSupport/decorators/subclass.js";
import { writer as y } from "../core/accessorSupport/decorators/writer.js";
import { diff as m } from "../core/accessorSupport/diffUtils.js";
import { ensureType as h, ensureString as b } from "../core/accessorSupport/ensureType.js";
import { collectArcadeFieldNames as g, collectField as v } from "../layers/support/fieldUtils.js";
import S from "../portal/Portal.js";
import V from "./Renderer.js";
import { VisualVariablesMixin as q } from "./mixins/VisualVariablesMixin.js";
import { rendererBackgroundFillSymbolProperty as I, rendererSymbolProperty as j } from "./support/commonProperties.js";
import _ from "./support/LegendOptions.js";
import w from "./support/UniqueValueInfo.js";
import { loadArcade as U } from "../support/arcadeOnDemand.js";
import { f as O, t as F } from "../chunks/persistableUrlUtils.js";
import { fetchStyle as x } from "../symbols/support/styleUtils.js";
import D from "../symbols/WebStyleSymbol.js";

var _E;

var M = s.getLogger("esri.renderers.UniqueValueRenderer"),
    N = h(w);

var R = _E = /*#__PURE__*/function (_q) {
  _inherits(E, _q);

  var _super = _createSuper(E);

  function E(e) {
    var _this;

    _classCallCheck(this, E);

    _this = _super.call(this, e), _this._valueInfoMap = {}, _this._isDefaultSymbolDerived = !1, _this.type = "unique-value", _this.backgroundFillSymbol = null, _this.field = null, _this.field2 = null, _this.field3 = null, _this.valueExpression = null, _this.valueExpressionTitle = null, _this.legendOptions = null, _this.defaultLabel = null, _this.fieldDelimiter = null, _this.portal = null, _this.styleOrigin = null, _this.diff = {
      uniqueValueInfos: function uniqueValueInfos(e, t) {
        if (!e && !t) return;
        if (!e || !t) return {
          type: "complete",
          oldValue: e,
          newValue: t
        };
        var i = !1;
        var r = {
          type: "collection",
          added: [],
          removed: [],
          changed: [],
          unchanged: []
        };

        var _loop = function _loop(_s) {
          var l = e.find(function (e) {
            return e.value === t[_s].value;
          });
          l ? m(l, t[_s]) ? (r.changed.push({
            type: "complete",
            oldValue: l,
            newValue: t[_s]
          }), i = !0) : r.unchanged.push({
            oldValue: l,
            newValue: t[_s]
          }) : (r.added.push(t[_s]), i = !0);
        };

        for (var _s = 0; _s < t.length; _s++) {
          _loop(_s);
        }

        var _loop2 = function _loop2(_s2) {
          t.find(function (t) {
            return t.value === e[_s2].value;
          }) || (r.removed.push(e[_s2]), i = !0);
        };

        for (var _s2 = 0; _s2 < e.length; _s2++) {
          _loop2(_s2);
        }

        return i ? r : void 0;
      }
    }, _this._set("uniqueValueInfos", []);
    return _this;
  }

  _createClass(E, [{
    key: "_cache",
    get: function get() {
      return {
        compiledFunc: null
      };
    }
  }, {
    key: "castField",
    value: function castField(e) {
      return null == e || "function" == typeof e ? e : b(e);
    }
  }, {
    key: "writeField",
    value: function writeField(e, t, r, s) {
      "string" == typeof e ? t[r] = e : s && s.messages ? s.messages.push(new i("property:unsupported", "UniqueValueRenderer.field set to a function cannot be written to JSON")) : M.error(".field: cannot write field to JSON since it's not a string value");
    }
  }, {
    key: "defaultSymbol",
    set: function set(e) {
      this._isDefaultSymbolDerived = !1, this._set("defaultSymbol", e);
    }
  }, {
    key: "readPortal",
    value: function readPortal(e, t, i) {
      return i.portal || S.getDefault();
    }
  }, {
    key: "readStyleOrigin",
    value: function readStyleOrigin(e, t, i) {
      if (t.styleName) return Object.freeze({
        styleName: t.styleName
      });

      if (t.styleUrl) {
        var _e = O(t.styleUrl, i);

        return Object.freeze({
          styleUrl: _e
        });
      }
    }
  }, {
    key: "writeStyleOrigin",
    value: function writeStyleOrigin(e, t, i, r) {
      e.styleName ? t.styleName = e.styleName : e.styleUrl && (t.styleUrl = F(e.styleUrl, r));
    }
  }, {
    key: "uniqueValueInfos",
    set: function set(e) {
      this.styleOrigin ? M.error("#uniqueValueInfos=", "Cannot modify unique value infos of a UniqueValueRenderer created from a web style") : (this._set("uniqueValueInfos", e), this._updateValueInfoMap());
    }
  }, {
    key: "addUniqueValueInfo",
    value: function addUniqueValueInfo(e, i) {
      if (this.styleOrigin) return void M.error("#addUniqueValueInfo()", "Cannot modify unique value infos of a UniqueValueRenderer created from a web style");
      var r;
      r = "object" == typeof e ? N(e) : new w({
        value: e,
        symbol: t(i)
      }), this.uniqueValueInfos.push(r), this._valueInfoMap[r.value] = r;
    }
  }, {
    key: "removeUniqueValueInfo",
    value: function removeUniqueValueInfo(e) {
      if (this.styleOrigin) M.error("#removeUniqueValueInfo()", "Cannot modify unique value infos of a UniqueValueRenderer created from a web style");else for (var _t = 0; _t < this.uniqueValueInfos.length; _t++) {
        if (this.uniqueValueInfos[_t].value === e + "") {
          delete this._valueInfoMap[e], this.uniqueValueInfos.splice(_t, 1);
          break;
        }
      }
    }
  }, {
    key: "getUniqueValueInfo",
    value: function () {
      var _getUniqueValueInfo2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t) {
        var i;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                i = t;
                _context.t0 = this.valueExpression && (l(t) || l(t.arcade));

                if (!_context.t0) {
                  _context.next = 11;
                  break;
                }

                _context.t1 = _objectSpread;
                _context.t2 = _objectSpread({}, i);
                _context.t3 = {};
                _context.next = 8;
                return U();

              case 8:
                _context.t4 = _context.sent;
                _context.t5 = {
                  arcade: _context.t4
                };
                i = (0, _context.t1)(_context.t2, _context.t3, _context.t5);

              case 11:
                return _context.abrupt("return", this._getUniqueValueInfo(e, i));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getUniqueValueInfo(_x, _x2) {
        return _getUniqueValueInfo2.apply(this, arguments);
      }

      return getUniqueValueInfo;
    }()
  }, {
    key: "getSymbol",
    value: function getSymbol(e, t) {
      if (this.valueExpression && (l(t) || l(t.arcade))) return void M.error("#getSymbol()", "Please use getSymbolAsync if valueExpression is used");

      var i = this._getUniqueValueInfo(e, t);

      return i && i.symbol || this.defaultSymbol;
    }
  }, {
    key: "getSymbolAsync",
    value: function () {
      var _getSymbolAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, t) {
        var i, _e2, _t2, r;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                i = t;

                if (!(this.valueExpression && (l(i) || l(i.arcade)))) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 4;
                return U();

              case 4:
                _e2 = _context2.sent;
                _t2 = _e2.arcadeUtils;
                _context2.t0 = _t2.hasGeometryOperations(this.valueExpression);

                if (!_context2.t0) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 10;
                return _t2.enableGeometryOperations();

              case 10:
                i = _objectSpread(_objectSpread({}, i), {}, {
                  arcade: _e2
                });

              case 11:
                r = this._getUniqueValueInfo(e, i);
                return _context2.abrupt("return", r && r.symbol || this.defaultSymbol);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSymbolAsync(_x3, _x4) {
        return _getSymbolAsync.apply(this, arguments);
      }

      return getSymbolAsync;
    }()
  }, {
    key: "getSymbols",
    value: function getSymbols() {
      var e = [];

      var _iterator = _createForOfIteratorHelper(this.uniqueValueInfos),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t3 = _step.value;
          _t3.symbol && e.push(_t3.symbol);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return this.defaultSymbol && e.push(this.defaultSymbol), e;
    }
  }, {
    key: "getAttributeHash",
    value: function getAttributeHash() {
      return this.visualVariables && this.visualVariables.reduce(function (e, t) {
        return e + t.getAttributeHash();
      }, "");
    }
  }, {
    key: "getMeshHash",
    value: function getMeshHash() {
      return "".concat(JSON.stringify(this.backgroundFillSymbol), ".").concat(JSON.stringify(this.defaultSymbol), ".").concat(this.uniqueValueInfos.reduce(function (e, t) {
        return e + t.getMeshHash();
      }, ""), ".", "".concat(this.field, ".").concat(this.field2, ".").concat(this.field3, ".").concat(this.fieldDelimiter), ".").concat(this.valueExpression);
    }
  }, {
    key: "clone",
    value: function clone() {
      var e = new _E({
        field: this.field,
        field2: this.field2,
        field3: this.field3,
        defaultLabel: this.defaultLabel,
        defaultSymbol: r(this.defaultSymbol),
        valueExpression: this.valueExpression,
        valueExpressionTitle: this.valueExpressionTitle,
        fieldDelimiter: this.fieldDelimiter,
        visualVariables: r(this.visualVariables),
        legendOptions: r(this.legendOptions),
        authoringInfo: this.authoringInfo && this.authoringInfo.clone(),
        backgroundFillSymbol: r(this.backgroundFillSymbol)
      });
      this._isDefaultSymbolDerived && (e._isDefaultSymbolDerived = !0), e._set("portal", this.portal);
      var t = r(this.uniqueValueInfos);
      return this.styleOrigin && (e._set("styleOrigin", Object.freeze(r(this.styleOrigin))), Object.freeze(t)), e._set("uniqueValueInfos", t), e._updateValueInfoMap(), e;
    }
  }, {
    key: "arcadeRequired",
    get: function get() {
      return this.arcadeRequiredForVisualVariables || !!this.valueExpression;
    }
  }, {
    key: "collectRequiredFields",
    value: function () {
      var _collectRequiredFields = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, t) {
        var i;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                i = [this.collectVVRequiredFields(e, t), this.collectSymbolFields(e, t)];
                _context3.next = 3;
                return Promise.all(i);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function collectRequiredFields(_x5, _x6) {
        return _collectRequiredFields.apply(this, arguments);
      }

      return collectRequiredFields;
    }()
  }, {
    key: "collectSymbolFields",
    value: function () {
      var _collectSymbolFields = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e, t) {
        var i;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                i = [].concat(_toConsumableArray(this.getSymbols().map(function (i) {
                  return i.collectRequiredFields(e, t);
                })), [g(e, t, this.valueExpression)]);
                v(e, t, this.field);
                v(e, t, this.field2);
                v(e, t, this.field3);
                _context4.next = 6;
                return Promise.all(i);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function collectSymbolFields(_x7, _x8) {
        return _collectSymbolFields.apply(this, arguments);
      }

      return collectSymbolFields;
    }()
  }, {
    key: "populateFromStyle",
    value: function populateFromStyle() {
      var _this2 = this;

      return x(this.styleOrigin, {
        portal: this.portal
      }).then(function (e) {
        var t = [];
        return _this2._valueInfoMap = {}, e && e.data && Array.isArray(e.data.items) && e.data.items.forEach(function (i) {
          var r = new D({
            styleUrl: e.styleUrl,
            styleName: e.styleName,
            portal: _this2.portal,
            name: i.name
          });
          _this2.defaultSymbol || i.name !== e.data.defaultItem || (_this2.defaultSymbol = r, _this2._isDefaultSymbolDerived = !0);
          var s = new w({
            value: i.name,
            symbol: r
          });
          t.push(s), _this2._valueInfoMap[i.name] = s;
        }), _this2._set("uniqueValueInfos", Object.freeze(t)), !_this2.defaultSymbol && _this2.uniqueValueInfos.length && (_this2.defaultSymbol = _this2.uniqueValueInfos[0].symbol, _this2._isDefaultSymbolDerived = !0), _this2;
      });
    }
  }, {
    key: "_updateValueInfoMap",
    value: function _updateValueInfoMap() {
      var _this3 = this;

      this._valueInfoMap = {}, this.uniqueValueInfos.forEach(function (e) {
        return _this3._valueInfoMap[e.value + ""] = e;
      });
    }
  }, {
    key: "_getUniqueValueInfo",
    value: function _getUniqueValueInfo(e, t) {
      return this.valueExpression ? this._getUnqiueValueInfoForExpression(e, t) : this._getUnqiueValueInfoForFields(e);
    }
  }, {
    key: "_getUnqiueValueInfoForExpression",
    value: function _getUnqiueValueInfoForExpression(e, t) {
      var _o = o(t, {}),
          i = _o.viewingMode,
          r = _o.scale,
          s = _o.spatialReference,
          l = _o.arcade;

      var a = this._cache.compiledFunc;
      var u = n(l).arcadeUtils;

      if (!a) {
        var _e3 = u.createSyntaxTree(this.valueExpression);

        a = u.createFunction(_e3), this._cache.compiledFunc = a;
      }

      var p = u.executeFunction(a, u.createExecContext(e, u.getViewInfo({
        viewingMode: i,
        scale: r,
        spatialReference: s
      })));
      return this._valueInfoMap[p + ""];
    }
  }, {
    key: "_getUnqiueValueInfoForFields",
    value: function _getUnqiueValueInfoForFields(e) {
      var t = this.field,
          i = e.attributes;
      var r;

      if ("function" != typeof t && this.field2) {
        var _e4 = this.field2,
            _s3 = this.field3,
            _l = [];
        t && _l.push(i[t]), _e4 && _l.push(i[_e4]), _s3 && _l.push(i[_s3]), r = _l.join(this.fieldDelimiter || "");
      } else "function" == typeof t ? r = t(e) : t && (r = i[t]);

      return this._valueInfoMap[r + ""];
    }
  }], [{
    key: "fromPortalStyle",
    value: function fromPortalStyle(e, t) {
      var i = new _E(t && t.properties);
      i._set("styleOrigin", Object.freeze({
        styleName: e
      })), i._set("portal", t && t.portal || S.getDefault());
      var r = i.populateFromStyle();
      return r.catch(function (t) {
        M.error("#fromPortalStyle('".concat(e, "'[, ...])"), "Failed to create unique value renderer from style name", t);
      }), r;
    }
  }, {
    key: "fromStyleUrl",
    value: function fromStyleUrl(e, t) {
      var i = new _E(t && t.properties);

      i._set("styleOrigin", Object.freeze({
        styleUrl: e
      }));

      var r = i.populateFromStyle();
      return r.catch(function (t) {
        M.error("#fromStyleUrl('".concat(e, "'[, ...])"), "Failed to create unique value renderer from style URL", t);
      }), r;
    }
  }]);

  return E;
}(q(V));

e([u({
  readOnly: !0
})], R.prototype, "_cache", null), e([f({
  uniqueValue: "unique-value"
})], R.prototype, "type", void 0), e([u(I)], R.prototype, "backgroundFillSymbol", void 0), e([u({
  json: {
    type: String,
    read: {
      source: "field1"
    },
    write: {
      target: "field1"
    }
  }
})], R.prototype, "field", void 0), e([p("field")], R.prototype, "castField", null), e([y("field")], R.prototype, "writeField", null), e([u({
  type: String,
  json: {
    write: !0
  }
})], R.prototype, "field2", void 0), e([u({
  type: String,
  json: {
    write: !0
  }
})], R.prototype, "field3", void 0), e([u({
  type: String,
  json: {
    write: !0
  }
})], R.prototype, "valueExpression", void 0), e([u({
  type: String,
  json: {
    write: !0
  }
})], R.prototype, "valueExpressionTitle", void 0), e([u({
  type: _,
  json: {
    write: !0
  }
})], R.prototype, "legendOptions", void 0), e([u({
  type: String,
  json: {
    write: !0
  }
})], R.prototype, "defaultLabel", void 0), e([u(a(_objectSpread({}, j), {
  json: {
    write: {
      overridePolicy: function overridePolicy() {
        return {
          enabled: !this._isDefaultSymbolDerived
        };
      }
    },
    origins: {
      "web-scene": {
        write: {
          overridePolicy: function overridePolicy() {
            return {
              enabled: !this._isDefaultSymbolDerived
            };
          }
        }
      }
    }
  }
}))], R.prototype, "defaultSymbol", null), e([u({
  type: String,
  json: {
    write: !0
  }
})], R.prototype, "fieldDelimiter", void 0), e([u({
  type: S,
  readOnly: !0
})], R.prototype, "portal", void 0), e([d("portal", ["styleName"])], R.prototype, "readPortal", null), e([u({
  readOnly: !0,
  json: {
    write: {
      enabled: !1,
      overridePolicy: function overridePolicy() {
        return {
          enabled: !0
        };
      }
    }
  }
})], R.prototype, "styleOrigin", void 0), e([d("styleOrigin", ["styleName", "styleUrl"])], R.prototype, "readStyleOrigin", null), e([y("styleOrigin", {
  styleName: {
    type: String
  },
  styleUrl: {
    type: String
  }
})], R.prototype, "writeStyleOrigin", null), e([u({
  type: [w],
  json: {
    write: {
      overridePolicy: function overridePolicy() {
        return this.styleOrigin ? {
          enabled: !1
        } : {
          enabled: !0
        };
      }
    }
  }
})], R.prototype, "uniqueValueInfos", null), R = _E = e([c("esri.renderers.UniqueValueRenderer")], R);
var P = R;
export { P as default };